import { afterNextRender, Component, Inject, inject, LOCALE_ID, OnInit } from '@angular/core';
import { BranchIoService } from "./shared/services/branch-io.service";
import { environment } from "../environments/environment";
import { HotjarService } from "./shared/services/hotjar.service";
import {
  ActivatedRoute,
  GuardsCheckEnd,
  GuardsCheckStart,
  NavigationCancel,
  NavigationEnd,
  Router
} from "@angular/router";
import { filter, map, mergeMap } from "rxjs";
import { SEOService } from "./shared/services/seo.service";
import { GoogleAnalyticsService } from "./shared/services/google-analytics.service";
import { PrimeNGConfig, Translation } from "primeng/api";
import { SuperChatService } from './shared/services/super-chat.service';
import { EmbedContextService } from "./shared/services/embed-context.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  showAppConfig = !environment.production;
  guardLoading = false;

  constructor(private readonly branchIoService: BranchIoService, private readonly googleAnalyticsService: GoogleAnalyticsService,
              private readonly hotjarService: HotjarService, private readonly router: Router, private readonly activatedRoute: ActivatedRoute, private readonly seoService: SEOService,
              @Inject(LOCALE_ID) public locale: string, private readonly superChatService: SuperChatService,
              private readonly embedContext: EmbedContextService) {
    // embedding sites cannot ask for cookie consent on our behalf, so we load no consent requiring
    // script there. None of these touch the rendered markup, so the stricter flag that also covers
    // iframes we were not embedded into by our own script is safe to use here.
    if (this.embedContext.canLoadThirdPartyScripts && environment.hotjarTrackingCode && environment.hotjarVersion) {
      this.hotjarService.initialize();
    }

    afterNextRender({ write: () => {
        if (!this.embedContext.canLoadThirdPartyScripts) {
          return;
        }
        this.branchIoService.init();
        this.googleAnalyticsService.initialize();
        // this.superChatService.initialize();
    } }, );
  }

  primeNgConfig = inject(PrimeNGConfig);

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof GuardsCheckStart) {
        this.guardLoading = true;
      }
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        this.guardLoading = false;
      }
    });

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
    )
      .subscribe((data) => {
        // Only routes that can describe themselves up front carry a title. The ones that cannot —
        // an event, a club — publish their preview from the loaded record instead, and this runs
        // after their component did, so writing the route's empty defaults here would wipe it and
        // leave the shared link showing nothing but the app name.
        if (!data['title']) return;

        this.seoService.updateTitle(data['title']);
        //Updating Description tag dynamically with title
        this.seoService.updateDescription(`${data['title']} ${data['description'] ?? ''}`);
        this.seoService.updateSocialPreview({
          title: data['title'],
          description: data['description'],
          url: data['ogUrl'],
        });
      });

    this.setPrimeNgConfig();
  }

  setPrimeNgConfig() {
    const localeTranslations: Record<string, Translation> = {
      'en': {
        dateFormat: 'mm/dd/yy',
        firstDayOfWeek: 1,
      },
      'de': {
        dateFormat: 'dd.mm.yy',
        firstDayOfWeek: 1,
      }
    }
    this.primeNgConfig.setTranslation(localeTranslations[this.locale]);

  }
}
